import moment from 'moment';
import { StyledCell } from '../Table.style';

const DATE_FORMAT = 'DD MMM YYYY HH:mm';

const DateCell = ({ date }) => {
  const dateInView = moment(date).isValid()
    ? moment(date).format(DATE_FORMAT)
    : '-';

  return <StyledCell>{dateInView}</StyledCell>;
};

export default DateCell;
